import { render, staticRenderFns } from "./FormList.vue?vue&type=template&id=6653a093&scoped=true"
import script from "./FormList.vue?vue&type=script&lang=js"
export * from "./FormList.vue?vue&type=script&lang=js"
import style0 from "./FormList.vue?vue&type=style&index=0&id=6653a093&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6653a093",
  null
  
)

export default component.exports